export default {
    basic: null,
    full: null,
    permissions: [],
};
